import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AdrDto, AdrAssetsDto } from '@cradua/data';

@Component({
  selector: 'cradua-assetsindispute',
  templateUrl: './assetsindispute.component.html',
  styleUrls: ['./assetsindispute.component.scss']
})
export class AssetsindisputeComponent implements OnInit {

  adrassetForm: FormGroup;
  @Input() selectedSuitProgresss: AdrDto;
  isToggle = false;
  listView = false;
  gridView = true;

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.adrassetForm = this.fb.group({
      AdrId: [''],
      LandName: [''],
      StateName: [''],
      LgaName: [''],
      CommunityName	: [''],
      Remarks: [''],
      id: ['']
    });   
    // if(this.selectedSuitProgresss?.adrAssets != null && this.selectedSuitProgresss?.adrAssets.length) {
    //   this.setAdrProgresss(this.selectedSuitProgresss?.adrAssets);
    // }      
  }

  setAdrProgresss(assetsindisp: AdrAssetsDto[]) {
    assetsindisp?.forEach(value => {
      this.adrassetForm.patchValue({
        AdrId: value.AdrId,
        LandName: value.LandName,
        StateName: value.StateName,
        LgaName: value.LgaName,
        CommunityName: value.CommunityName,
        Remarks: value.Remarks,
        id: value.id
      });
     });
   }

   onList() {
    this.listView = true;
    this.gridView = false;
  }

  onGrid() {
    this.gridView = true;
    this.listView = false;
  }

}
